import React from 'react';
import jQuery from 'jquery';
import Configurator from './Configurator.jsx';
import Button from "./ui/button/Button.jsx";
import Image from './ui/features/Image.jsx';
import styles from './OpticConfigurator.styl';
import Table from "./ui/features/Table.jsx";



// Константы
const FIBER_NUM = 'Количество волокон'
const FIBER_TYPE = 'Категории волокна_Name'
const EXT_DIAM = 'Внешн диаметр - прибл мм'
const CABEL_LENGTH = 'Длина м'
const CONNECTOR_TYPE = 'Тип коннектора подключения 1_Name'
const CONNECTOR_TYPE1 = 'Тип коннектора подключения 1_Name'
const CONNECTOR_TYPE2 = 'Тип коннектора подключения 2_Name'
const POLISH = 'Полировка_Name'
const CABLE_TYPE = 'Тип кабеля_Name'
const PLUG_TYPE = 'Тип соединителя или разъема_Name'
const FIBER_CLASS = 'Класс волокна_Name'
const ADAPTER_NUMB = 'Количество портов'
const MOUNT_TYPE = 'Тип монтажа_Name'
const FIBER_TYPE_PATCH = 'Категория_Name'
const MATCH_FOR = 'Подходит для_Name'
const MODUL_NUM = 'Количество модулей в высоту'

const COMPLECT = 'Укомплектованный'
const SPARE_PARTS = 'Комплектующие для сборки'


const initialState ={
	filterFibersNum: 'Выбрать',				// Выбранное значение количества волокон
	filterFibersType: 'Выбрать',			// Выбранное значение типа волокон
	filterExtMat: 'Выбрать',					// Выбранное значение материала внешней оболочки
	filterExtDiam: 'Выбрать',					// Выбранное значение диаметра внешней оболочки
	filterCableLength: 'Выбрать',				// Выбранное значение диаметра внешней оболочки

	//Патч-корды
	filterPatchConType: 'Выбрать',		// Выбранное значение типа коннектора
	filterPatchPol: 'Выбрать',					// Выбранное значение полировки
	filterPatchCable: 'Выбрать',			// Выбранное значение типа кабеля

	//Пигтейлы
	filterPigtailPol: 'Выбрать',			// Выбранное значение типа полировки
	filterPigtailCon: 'Выбрать',			// Выбранное значение типа коннектора

	//Опт-кроссы
	filterOptCrossAdaptType: 	'Выбрать',	// Выбранное тип адаптера
	filterOptMountType: 			'Выбрать',	// Выбранное тип монтажа
	filterOptFullNumb: 				'Выбрать',	// Выбранное количество модулей
	filterOptCrossAdaptQuant: 'Выбрать',// Выбранное значение количества адаптеров
	filterTurnkey: 						COMPLECT,	// Выбранное подбор готового опткросса, или собрать собственное решение

	//Доп компоненты
	filterAddPole: 'Выбрать',					// Выбранное значение типа полировки
	filterAddConType: 'Выбрать',			// Выбранное значение типа коннектора
	filterAddFullNumb: 'Выбрать',			// Выбранное значение типа коннектора
}
class OpticConfigurator extends Configurator {

	componentDidMount() {
		this.getItemList()
	}

	//Конструктор
	constructor(props) {
		super(props);
		this.state={

			//Списки
			itemList: [], 										// Подобранные аксессуары
			specList: [], 										// Спецификация оборудования
			cableList: [], 										// Список кабелей
			adapterList: [], 									// Список адаптеров
			patchCordList: [], 								// Список патч кордов
			pigtailList: [], 									// Список пигтейлов
			plugList: [], 										// Список заглушек
			optCrossList: [], 								// Список оптических кроссов
			addModuleList: [], 								// Список дополнительных модулей
			addList: [], 											// Список дополнительных компонентов
			panelList: [], 										// Список панелей
			summ: 0,

			//Основной фильтр
			filterDevice: 'Выбрать',						//Выбранное значение основного фильтра

			//Кабели
			fibersNumOptions:[],							// Варианты выбора количества волокон
			fibersTypeOptions:[],							// Варианты выбора типа волокон
			extMatOptions:[],									// Варианты выбора материала внешней оболочки
			extDiamOptions:[],								// Варианты выбора диаметра внешней оболочки
			cableLengthOptions:[],						// Варианты выбора диаметра внешней оболочки

			//Патч-корды
			patchConTypeOptions:[],						// Варианты выбора типа коннектора
			patchPolOptions:[],								// Варианты выбора полировки
			patchCableOptions:[],							// Варианты выбора типа кабеля

			//Пигтейлы
			pigtailPolOptions:[],							// Варианты выбора типа полировки
			pigtailConOptions:[],							// Варианты выбора типа коннектора

			//Опт-кроссы
			optCrossPoleOptions:[],						  // Варианты выбора полировки
			optCrossAdaptTypeOptions:[],				// Варианты тип адаптера
			optMountTypeOptions:[],							// Варианты тип монтажа
			optFullNumbOptions:[],							// Количество модулей в высоту
			optCrossAdaptQuantOptions:[],				// Варианты выбора количества адаптеров
			optCrossTurnkeyOptions: [COMPLECT, SPARE_PARTS],				// Варианты выбора количества адаптеров

			//Доп компоненты
			addPoleOptions:[],								// Варианты выбора типа полировки
			addConTypeOptions:[],							// Варианты выбора типа коннектора
			addFullNumbOptions:[],						// Варианты выбора типа коннектора

			//Высота таблицы
			tableHeight: '416px',
			tableTop: '341px',
			optCrossBGHeight:'190px',

			addFilterEnabled:false,

			...initialState,
		}

		// Обработка событий таблиц
		this.onChangeQuantity 									= this.onChangeQuantity.bind(this);
		this.addBasket 													= this.addBasket.bind(this);
		this.onDelete 													= this.onDelete.bind(this);

		this.onFilterChange									= this.onFilterChange.bind(this);

		this.cableDropDown									= this.cableDropDown.bind(this);
		this.patchCordDropDown							= this.patchCordDropDown.bind(this);
		this.pigtailDropDown								= this.pigtailDropDown.bind(this);
		this.optCrossDropDown								= this.optCrossDropDown.bind(this);
		this.addDropDown										= this.addDropDown.bind(this);

		this.onFibersNumChange							= this.onFibersNumChange.bind(this);
		this.onFibersTypeChange							= this.onFibersTypeChange.bind(this);
		this.onExtMatChange									= this.onExtMatChange.bind(this);
		this.onExtDiamChange								= this.onExtDiamChange.bind(this);
		this.onCableLengthChange						= this.onCableLengthChange.bind(this);

		this.onPatchConTypeChange						= this.onPatchConTypeChange.bind(this);
		this.onPatchPolChange								= this.onPatchPolChange.bind(this);
		this.onPatchCableChange							= this.onPatchCableChange.bind(this);

		this.onPigtailPolChange							= this.onPigtailPolChange.bind(this);
		this.onPigtailConChange							= this.onPigtailConChange.bind(this);

		this.onOptCrossPoleChange				  	= this.onOptCrossPoleChange.bind(this);
		this.onOptCrossAdaptTypeChange			= this.onOptCrossAdaptTypeChange.bind(this);
		this.onOptMountTypeChange						= this.onOptMountTypeChange.bind(this);
		this.onOptFullNumbChange						= this.onOptFullNumbChange.bind(this);
		this.onOptCrossAdaptQuantChange			= this.onOptCrossAdaptQuantChange.bind(this);

		this.onAddPoleChange								= this.onAddPoleChange.bind(this);
		this.onAddConTypeChange							= this.onAddConTypeChange.bind(this);
		this.onAddFullNumbChange						= this.onAddFullNumbChange.bind(this);

		//Кнопки
		this.onClearFiltersClick 						= this.onClearFiltersClick.bind(this);
		this.doPrint 												= this.doPrint.bind(this);
		this.onBtnExcelClick 								= this.onBtnExcelClick.bind(this);

		//Служебные процедуры
		this.getItemList 										= this.getItemList.bind(this);
		this.getOptions 										= this.getOptions.bind(this);
		this.getArrayFromAttribute 					= this.getArrayFromAttribute.bind(this);
		this.filterArrayExtMat 							= this.filterArrayExtMat.bind(this);
		this.filterArrayFiber 							= this.filterArrayFiber.bind(this);

		this.getOptionsForExtMat 						= this.getOptionsForExtMat.bind(this);

		this.getFilteredCableArray 					= this.getFilteredCableArray.bind(this);
		this.changeCableFilterOptions 			= this.changeCableFilterOptions.bind(this);
		this.filterArray 										= this.filterArray.bind(this);
		this.orderArray 										= this.orderArray.bind(this);

		this.openPatchCord 									= this.openPatchCord.bind(this);
		this.getFilteredPatchCordArray 			= this.getFilteredPatchCordArray.bind(this);
		this.changePatchCordFilterOptions 	= this.changePatchCordFilterOptions.bind(this);

		this.openPigtail 										= this.openPigtail.bind(this);
		this.getFilteredPigtailArray 				= this.getFilteredPigtailArray.bind(this);
		this.changePigtailFilterOptions 		= this.changePigtailFilterOptions.bind(this);

		this.openOptCross										= this.openOptCross.bind(this);
		this.getFilteredOptCrossArray 			= this.getFilteredOptCrossArray.bind(this);
		this.changeOptCrossFilterOptions 		= this.changeOptCrossFilterOptions.bind(this);

		this.openAdd												= this.openAdd.bind(this);
		this.getFilteredAddArray 						= this.getFilteredAddArray.bind(this);
		this.changeAddFilterOptions 				= this.changeAddFilterOptions.bind(this);

		this.dropDownChangeHandler      		= this.dropDownChangeHandler.bind(this);
		this.mainDropDownChangeHandler      = this.mainDropDownChangeHandler.bind(this);

		this.onTurnkeyChange 								= this.onTurnkeyChange.bind(this)

		this.clearFromDouble 								= this.clearFromDouble.bind(this)
	}

// ++ Для Запуска

	getCustomStyles() {
		return styles;
	}

	getType() {
		return 'optic';
	}

	// -- Для Запуска


	// ++ Работа таблиц

	//Отображение выбранного значения
	onListItemCheck(item) {
		super.onListItemCheck(item.article)
	}

	// ++ Обработка печати
	doPrint(params) {
		let _params = params || {};
		_params.data = {
			specList: JSON.stringify(this.state.specList)
		};
		super.doPrint(_params);
	}

	onBtnExcelClick() {
		this.doPrint({format: 'xls'});
	}
// -- Обработка печати

	// Добавить элемент в корзину
	addBasket(item) {

		jQuery.getJSON(
			'itkcfg.php',
			{
				type: 'optic',
				action: 'getItemPriceNSI',
				article: item.article,
				groupId: '20.04'
			},	result => {
				let price = result[0].price

				this.setState(prevState => {
					const specList = [...prevState.specList]
					if (specList.some(i => i.article === item.article)) {
						specList.map(i => {
							if(i.article === item.article) {
								i.count = Number(i.count) + 1
								i.sum = (i.price*i.count).toFixed(2)
							}
							return i
						})
					} else {
						item.count = 1
						item.sum = (item.count*price).toFixed(2)
						item = {...item, 'price': price}
						specList.push(item)
					}
					let summ = specList.map(item => item.price*item.count).reduce((previousValue, currentValue) => {
						return previousValue + currentValue
					}).toFixed(2)
					return {specList, summ}
				})
			})
	}

	//Удаление
	onDelete(item) {

		this.setState((prevState) => {
			return {
				...prevState,
				specList: prevState.specList.filter((el) => el.article !== item.article)
			}
		}, ()=>{
			let specList = this.state.specList
			let summ = 0
			if(specList.length){
				summ= specList.map(item => item.price).reduce((previousValue, currentValue) => {
					return previousValue + currentValue
				}).toFixed(2)
			}
			this.setState({summ})
		})

	}

	// Изменение количества позиции
	onChangeQuantity(item, value) {

		this.setState(prevState => {
			const newBasket = prevState.specList.map(i => {
				if (i.article === item.article) {
					i.count = value
					i.sum = (value*item.price).toFixed(2)
				}
				return i
			})
			let summ = prevState.specList.map(item => item.price*item.count).reduce((previousValue, currentValue) => {
				return previousValue + currentValue
			}).toFixed(2)
			return {
				specList: newBasket,
				summ
			}
		})
	}

// -- Работа таблиц

	// ++ Служебные процедуры и функции

	getItemList(){
		jQuery.getJSON(
			'itkcfg.php',
			{
				type: this.getType(),
				action: 'getItemListNSI',
				groupId:'20.04'
			},
			items => {
				let db = items.map(item => {return{...item, article:item.Code}})
				const newArr = items.reduce((counter, item) =>{
					if(item.name.includes("Кабель оптический")) counter.cableList.push({...item, article:item.Code})
					if(item.name.includes("Проходной адаптер")) counter.adapterList.push({...item, article:item.Code})
					if(item.name.includes("пигтеил")) counter.pigtailList.push({...item, article:item.Code})
					if(item.name.includes("патч-корд")) counter.patchCordList.push({...item, article:item.Code})
					if(item.name.includes("ITK Заглушка")) counter.plugList.push({...item, article:item.Code})
					if(item.name.includes("кросс") && !item.name.includes("Панель")) counter.optCrossList.push({...item, article:item.Code})
					if(item.name.includes("плайс-кассет")
						||item.name.includes("озетк")
						||item.name.includes("розетк")
						||item.name.includes("Комплект для защиты сварки")
					) counter.addList.push({...item, article:item.Code})
					if(item.name.includes("Панель")) counter.panelList.push({...item, article:item.Code})
					if(item.name.includes("Модуль Keystone")) counter.addModuleList.push({...item, article:item.Code})
					return counter
				},{
					cableList:[],
					adapterList:[],
					pigtailList:[],
					patchCordList:[],
					plugList:[],
					optCrossList:[],
					addModuleList:[],
					addList:[],
					panelList:[],
				})

				newArr.adapterList = newArr.adapterList.map(item =>{return {...item, polish:item.name.split(',')[2].trim()} })

				newArr.optCrossList = newArr.optCrossList.map(item =>{
					let adapter_type = ''
					if(item.name.includes('(')) adapter_type = item.name.split('(')[1].split(' ')[0]
					if(adapter_type.includes(')')) adapter_type = adapter_type.trim().slice(0,-1)
					return {...item,adapter_type}
				})
				this.setState({
					itemList: db,
					cableList:newArr.cableList,
					adapterList:newArr.adapterList,
					patchCordList:newArr.patchCordList,
					pigtailList:newArr.pigtailList,
					plugList:newArr.plugList,
					optCrossList:newArr.optCrossList,
					addModuleList:newArr.addModuleList,
					addList:newArr.addList,
					panelList:newArr.panelList,
				},()=>{
					this.changeCableFilterOptions(this.state.cableList)
				})
			}
		);
	}

	getArrayFromAttribute(array, attribute) {
		let fullArray = array.map(item => {
			let intArray = item.Features.filter(item => {
				return item.Attribute === attribute
			})
			if (intArray.length>0){
				return intArray[0].value
			}
		})
		fullArray = fullArray.filter(item => (item))
		let result = this.delDuplicatesFromArray(fullArray)
		result.unshift('Выбрать')
		return result
	}

	filterArray(option, array, value){
		if (option !== 'Выбрать'){
			array = array.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === value})
				if (intArray.length){
					return intArray[0].value === option
				}
			})
			array = array.filter(Boolean)
		}
		return array
	}

	orderArray(array){
		return array.sort((a,b) => Number(a) - Number(b))
	}

	dropDownChangeHandler(groupType, filterType, value){
		let obj = {}
		let itemList = this.getFilteredCableArray()
		let	addList = this['getFiltered' + groupType + 'Array'](value, filterType)
		this['change' + groupType + 'FilterOptions'](addList, value, filterType)
		switch (groupType) {
			case 'Cable':
				switch (filterType) {
					case 'fibers': obj = {filterFibersNum: value}; break;
					case 'fiber_type': obj = {filterFibersType: value}; break;
					case 'ext_mat': obj = {filterExtMat: value}; break;
					case 'ext_diam': obj = {filterExtDiam: value}; break;
					case 'cable_length': obj = {filterCableLength: value}; break;
				} break;
			case 'PatchCord':
				switch (filterType) {
					case 'conector_type': obj = {filterPatchConType: value}; break;
					case 'polish': obj = {filterPatchPol: value}; break;
					case 'cable_type': obj = {filterPatchCable: value}; break;
				} break;
			case 'Pigtail':
				switch (filterType) {
					case 'polish': obj = {filterPigtailPol: value}; break;
					case 'conector_type': obj = {filterPigtailCon: value}; break;
				} break;
			case 'OptCross':
				switch (filterType) {
					case 'adapter_type': obj = {filterOptCrossAdaptType: value}; break;
					case 'mount_type': obj = {filterOptMountType: value}; break;
					case 'opt_full_numb': obj = {filterOptFullNumb: value}; break;
					case 'adapter_numb': obj = {filterOptCrossAdaptQuant: value}; break;
				} break;
			case 'Add':
				switch (filterType) {
					case 'polish': obj = {filterAddPole: value}; break;
					case 'conector_type': obj = {filterAddConType: value}; break;
					case 'add_full_numb': obj = {filterAddFullNumb: value}; break;
				} break;
		}
		itemList = [...itemList, ...addList]
		obj ={...obj, itemList}
		this.setState(obj)
	}

	mainDropDownChangeHandler(filterType, value) {
		let obj
		let itemList = this.getFilteredCableArray(value, filterType)
		this.changeCableFilterOptions(itemList, value, filterType)

		obj = {itemList}

		if (this.state.addFilterEnabled) {
			obj = {
				...obj,
				filterDevice: 'Выбрать',
				filterTurnkey: COMPLECT,
				optCrossBGHeight:'190px',
				addFilterEnabled: value !== 'Выбрать',
				tableHeight: '416px',
				tableTop: '341px',
			}
		}
		switch (filterType) {
			case 'fibers': obj = {...obj, filterFibersNum: value}; break;
			case 'fiber_type': obj = {...obj, filterFibersType: value}; break;
			case 'ext_mat': obj = {...obj, filterExtMat: value}; break;
			case 'ext_diam': obj = {...obj, filterExtDiam: value}; break;
			case 'cable_length': obj = {...obj, filterCableLength: value}; break;
		}
		this.setState(obj)
	}

	getOptions(array, param){
		let result = this.delDuplicatesFromArray(array.map(item => item[param]))
		result = result.filter(item => item)
		result.unshift('Выбрать')
		return result
	}

	getOptionsForExtMat(list){
		let result = []
		list.map(item =>{
			if(item.name.includes('(А)-FRLSLTx')) result.push('FRLSLTx')
			else if(item.name.includes('(А)-HF')) result.push('HF')
			else result.push('PVC')
		})
		result = this.delDuplicatesFromArray(result)
		result = result.filter(item => item)
		result.unshift('Выбрать')
		return result
	}

	filterArrayExtMat(option, array){
		if (option !== 'Выбрать'){
			switch (option){
				case 'FRLSLTx': array = array.filter(item => item.name.includes('(А)-FRLSLTx')); break;
				case 'HF': array = array.filter(item => item.name.includes('(А)-HF')); break
				case 'PVC': array = array.filter(item => !item.name.includes('(А)-HF') && !item.name.includes('(А)-FRLSLTx')); break
			}
			array = array.filter(Boolean)
		}
		return array
	}

	filterArrayFiber(option, array, value){
		if (option !== 'Выбрать'){
			array = array.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === value})
				if (intArray.length){
					return intArray[0].value.includes(option)
				}
			})
			array = array.filter(Boolean)
		}
		return array
	}

	// -- Служебные процедуры и функции

	// ++ Дропдауны
	cableDropDown(){
		let elements = [];
		elements.push(<DropDown type='fibersNum' x={40} y={155} header='Количество волокон:' key={'cable'+1} app={this}/> )
		elements.push(<DropDown type='fibersType' x={40} y={205} header='Тип волокон:' key={'cable'+2} app={this}/> )
		elements.push(<DropDown type='extMat' x={180} y={155} header='Тип внеш. оболочки:' key={'cable'+3} app={this}/> )
		elements.push(<DropDown type='extDiam' x={180} y={205} header='Внешний диаметр:' key={'cable'+4} app={this}/> )
		elements.push(<DropDown type='cableLength' x={320} y={155} header='Монтажная длина:' key={'cable'+5} app={this}/> )
		return elements
	}

	patchCordDropDown(){
		let elements = [];
		elements.push(<DropDown type='patchConType' x={40} y={395} header='Тип коннектора:' key={'patchCord'+1} app={this}/> )
		elements.push(<DropDown type='patchPol' x={180} y={395} header='Полировка:' key={'patchCord'+3} app={this}/> )
		elements.push(<DropDown type='patchCable' x={320} y={395} header='Тип кабеля:' key={'patchCord'+4} app={this}/> )
		return elements
	}

	pigtailDropDown() {
		let elements = [];
		elements.push(<DropDown type='pigtailPol' x={40} y={395} header='Полировка:' key={'pigtail'+1} app={this}/>)
		elements.push(<DropDown type='pigtailCon' x={180} y={395} header='Тип соединения:' key={'pigtail'+2} app={this}/> )
		return elements
	}

	optCrossDropDown(){
		let elements = [];
		elements.push(<DropDown type='optCrossAdaptQuant' x={40} y={425} header='Количество адаптеров:' key={'optCross'+1} app={this}/> )
		elements.push(<DropDown type='optCrossAdaptType' x={180} y={425} header='Тип адаптера:' key={'optCross'+2} app={this}/> )
		elements.push(<DropDown type='optMountType' x={320} y={425} header='Тип монтажа:' key={'optCross'+3} app={this}/> )
		elements.push(<DropDown type='optFullNumb' x={40} y={480} header='Количество U:' key={'optCross'+4} app={this}/> )
		return elements
	}

	addDropDown() {
		let elements = [];
		elements.push(<DropDown type='addPole' x={40} y={425} header='Полировки:' key={'add'+1} app={this}/> )
		elements.push(<DropDown type='addConType' x={180} y={425} header='Тип соединения:' key={'add'+2} app={this}/> )
		elements.push(<DropDown type='addFullNumb' x={320} y={425} header='Количество U:' key={'add'+3} app={this}/> )
		return elements
	}

	// -- Дропдауны

	// ++Кнопки
	getCustomButtons() {
		let elements = [];
		elements.push(
			<button
				style={{top: '294px', left: '160px'}}
				className={styles.ResetButton}
				onClick={this.onClearFiltersClick}
			>Сбросить фильтр</button>)

		elements.push(
			<Button
				x="736"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.pdfBtnIcon}
				text="Сохранить в PDF"
				onClick={this.onBtnPrintPdfClick}
				key="printpdf"
			/>
		);

		elements.push(
			<Button
				x="940"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.printBtnIcon}
				text="Распечатать"
				onClick={this.onBtnPrintClick}
				key="print"
			/>
		);

		elements.push(
			<Button
				x="1144"
				y="764"
				buttonStyle={styles.mainBtn}
				textStyle={styles.mainBtnText}
				iconStyle={styles.excelBtnIcon}
				text="Сохранить в Excel"
				onClick={this.onBtnExcelClick}
				key="excel"
			/>
		);

		return elements;
	}
	//-- Кнопки


	// ++ Обработка событий

	// ++ Дропдауны

	onFilterChange(event){

		let deviseType = event.target.value
		this.setState({
			filterDevice:deviseType
		},()=>{
			let tableHeight = '416px'
			let tableTop = '341px'

			switch (this.state.filterDevice) {

				case 'pigtail':
					tableHeight = '277px'
					tableTop = '475px'
					this.openPigtail()
					break;

				case 'patch_cord':
					tableHeight = '277px'
					tableTop = '475px'
					this.openPatchCord()
					break;

				case 'opt_cross':
					tableHeight = '207px'
					tableTop = '550px'
					this.openOptCross()
					break;

				case 'Выбрать':
					let itemList = this.getFilteredCableArray()
					this.setState({itemList})
					break;
			}

			this.setState({
				tableHeight,
				tableTop,
			})
		})
	}

	onFibersNumChange(event){
		this.mainDropDownChangeHandler( 'fibers', event.target.value)
	}

	onFibersTypeChange(event){
		this.mainDropDownChangeHandler('fiber_type', event.target.value)
	}

	onExtMatChange(event){
		this.mainDropDownChangeHandler('ext_mat', event.target.value)
	}

	onExtDiamChange(event){
		this.mainDropDownChangeHandler( 'ext_diam', event.target.value)
	}

	onCableLengthChange(event){
		this.mainDropDownChangeHandler('cable_length', event.target.value)
	}


	onPatchConTypeChange(event){
		this.dropDownChangeHandler('PatchCord', 'conector_type', event.target.value)
	}

	onPatchPolChange(event){
		this.dropDownChangeHandler('PatchCord', 'polish', event.target.value)
	}

	onPatchCableChange(event){
		this.dropDownChangeHandler('PatchCord', 'cable_type', event.target.value)
	}


	onPigtailPolChange(event){
		this.dropDownChangeHandler('Pigtail', 'polish', event.target.value)
	}

	onPigtailConChange(event){
		this.dropDownChangeHandler('Pigtail', 'conector_type', event.target.value)
	}


	onOptCrossPoleChange(event){
		this.dropDownChangeHandler('OptCross', 'polish', event.target.value)
	}

	onOptCrossAdaptTypeChange(event){
		this.dropDownChangeHandler('OptCross', 'adapter_type', event.target.value)
	}

	onOptMountTypeChange(event){
		this.dropDownChangeHandler('OptCross', 'mount_type', event.target.value)
	}

	onOptFullNumbChange(event){
		this.dropDownChangeHandler('OptCross', 'opt_full_numb', event.target.value)
	}

	onOptCrossAdaptQuantChange(event){
		this.dropDownChangeHandler('OptCross', 'adapter_numb', event.target.value)
	}


	onAddPoleChange(event){
		this.dropDownChangeHandler('Add', 'polish', event.target.value)
	}

	onAddConTypeChange(event){
		this.dropDownChangeHandler('Add', 'conector_type', event.target.value)
	}

	onAddFullNumbChange(event){
		this.dropDownChangeHandler('Add', 'add_full_numb', event.target.value)
	}

	// -- Дропдауны

	// ++ Чекбоксы
	onTurnkeyChange(event){
		const filterTurnkey = event.target.value
		const tableHeight = filterTurnkey === COMPLECT ? '207px' : '237px'
		const tableTop = filterTurnkey === COMPLECT ? '550px' : '520px'
		const optCrossBGHeight = filterTurnkey === COMPLECT ? '190px' : '160px'

		this.setState({
			filterTurnkey,
			tableHeight,
			tableTop,
			optCrossBGHeight
		}, () => {
			filterTurnkey === COMPLECT ? this.openOptCross() : this.openAdd()
		})
	}

	// -- Чекбоксы


	onClearFiltersClick(){
		let itemList = this.state.cableList

		this.setState({
			itemList,
			...initialState,
			filterDevice: 'Выбрать',
			addFilterEnabled: false,
			tableHeight: '416px',
			tableTop: '341px',
			optCrossBGHeight:'190px',
		},
			()=>{
				this.changeCableFilterOptions(this.state.cableList)
		})
	}

	// -- Обработка событий

// ++ Логика

	//Кабели
	getFilteredCableArray(value = null, type = null){

		const fiberNum =						type === 'fibers' ? value : this.state.filterFibersNum
		const fiberType =						type === 'fiber_type' ? value : this.state.filterFibersType
		const extMat =							type === 'ext_mat' ? value : this.state.filterExtMat
		const extDiam =							type === 'ext_diam' ? value : this.state.filterExtDiam
		const cableLength =					type === 'cable_length' ? value : this.state.filterCableLength

		let list = this.state.cableList

		list = this.filterArray(fiberNum,list, FIBER_NUM)
		list = this.filterArrayFiber(fiberType,list, FIBER_TYPE)
		list = this.filterArrayExtMat(extMat, list)
		list = this.filterArray(extDiam,list, EXT_DIAM)
		list = this.filterArray(cableLength,list, CABEL_LENGTH)

		return list

	}
	changeCableFilterOptions(itemList, value = null, type = null){
		let addFilterEnabled = true
		const fiberNum =						type === 'fibers' ? value : this.state.filterFibersNum
		const fiberType =						type === 'fiber_type' ? value : this.state.filterFibersType
		const extMat =							type === 'ext_mat' ? value : this.state.filterExtMat
		const extDiam =							type === 'ext_diam' ? value : this.state.filterExtDiam
		const cableLength =					type === 'cable_length' ? value : this.state.filterCableLength

		let fibersNumOptions			= this.state.fibersNumOptions
		let fibersTypeOptions 		= this.state.fibersTypeOptions
		let extMatOptions 				= this.state.extMatOptions
		let extDiamOptions 				= this.state.extDiamOptions
		let cableLengthOptions 		= this.state.cableLengthOptions

		if (fiberNum === 'Выбрать'){
			fibersNumOptions = this.orderArray(this.getArrayFromAttribute(itemList, FIBER_NUM))
			addFilterEnabled = false
		}
		if (fiberType === 'Выбрать'){
			fibersTypeOptions = this.getArrayFromAttribute(itemList, FIBER_TYPE)
			fibersTypeOptions.shift()
			fibersTypeOptions = this.delDuplicatesFromArray(fibersTypeOptions.map(item => item.slice(0, 3)))
			fibersTypeOptions.unshift('Выбрать')
			addFilterEnabled = false
		}
		if (extMat === 'Выбрать') {
			extMatOptions = this.getOptionsForExtMat(itemList)
			addFilterEnabled = false
		}
		if (extDiam === 'Выбрать') {
			extDiamOptions = this.getArrayFromAttribute(itemList, EXT_DIAM)
			addFilterEnabled = false
		}
		if (cableLength === 'Выбрать') {
			cableLengthOptions = this.orderArray(this.getArrayFromAttribute(itemList, CABEL_LENGTH))
			addFilterEnabled = false
		}

		return this.setState({
			fibersNumOptions,
			fibersTypeOptions,
			extMatOptions,
			extDiamOptions,
			cableLengthOptions,
			addFilterEnabled
		})

	}

	// Патч-корды
	openPatchCord(){
		let itemList = this.getFilteredCableArray()
		const list = this.getFilteredPatchCordArray()
		this.changePatchCordFilterOptions(list)
		itemList = itemList.concat(list)
		this.setState({itemList})
	}
	getFilteredPatchCordArray(value = null, type = null){

		const fiberType = 							this.state.filterFibersType
		const conectType =							type === 'conector_type' ? value : this.state.filterPatchConType
		const polish =									type === 'polish' ? value : this.state.filterPatchPol
		const cableType =								type === 'cable_type' ? value : this.state.filterPatchCable

		let list = this.state.patchCordList

		list = this.filterArray(conectType, list, CONNECTOR_TYPE)
		list = this.filterArray(polish, list, POLISH)
		list = this.filterArray(cableType, list, CABLE_TYPE)
		list = this.filterArray(fiberType, list, FIBER_TYPE_PATCH)

		return list

	}
	changePatchCordFilterOptions(itemList, value = null, type = null){

		const conectType =						type === 'conector_type' ? value : this.state.filterPatchConType
		const polish =								type === 'polish' ? value : this.state.filterPatchPol
		const cableType =							type === 'cable_type' ? value : this.state.filterPatchCable

		let patchConTypeOptions				= this.state.patchConTypeOptions
		let patchPolOptions						= this.state.patchPolOptions
		let patchCableOptions 				= this.state.patchCableOptions

		if (conectType === 'Выбрать') patchConTypeOptions = this.getArrayFromAttribute(itemList, CONNECTOR_TYPE)
		if (polish === 'Выбрать') patchPolOptions = this.getArrayFromAttribute(itemList, POLISH)
		if (cableType === 'Выбрать') patchCableOptions = this.getArrayFromAttribute(itemList, CABLE_TYPE)

		return this.setState({
			patchConTypeOptions,
			patchPolOptions,
			patchCableOptions,
		})

	}

	// Пигтейлы
	openPigtail(){
		let itemList = this.getFilteredCableArray()
		const list = this.getFilteredPigtailArray()
		this.changePigtailFilterOptions(list)
		itemList = itemList.concat(list)
		this.setState({itemList})
	}
	getFilteredPigtailArray(value = null, type = null){

		const fiberType = 							this.state.filterFibersType
		const polish =									type === 'polish' ? value : this.state.filterPigtailPol
		const conectorType =						type === 'conector_type' ? value : this.state.filterPigtailCon

		let list = this.state.pigtailList

		list = this.filterArray(polish, list, POLISH)
		list = this.filterArray(fiberType, list, FIBER_TYPE_PATCH)
		list = this.filterArray(conectorType, list, PLUG_TYPE)

		return list

	}
	changePigtailFilterOptions(itemList, value = null, type = null){

		const polish =									type === 'polish' ? value : this.state.filterPigtailPol
		const conectorType =						type === 'conector_type' ? value : this.state.filterPigtailCon

		let pigtailPolOptions					= this.state.pigtailPolOptions
		let pigtailConOptions					= this.state.pigtailConOptions

		if (polish === 'Выбрать') pigtailPolOptions = this.getArrayFromAttribute(itemList, POLISH)
		if (conectorType === 'Выбрать') pigtailConOptions = this.getArrayFromAttribute(itemList, PLUG_TYPE)

		return this.setState({
			pigtailPolOptions,
			pigtailConOptions,
		})

	}

	// Оптические кроссы
	openOptCross(){
		let itemList = this.getFilteredCableArray()
		const list = this.getFilteredOptCrossArray()
		this.changeOptCrossFilterOptions(list)
		itemList = itemList.concat(list)
		this.setState({itemList, filterTurnkey:COMPLECT})
	}
	getFilteredOptCrossArray(value = null, type = null){

		const fiberType = 								this.state.filterFibersType
		const adapterType =								type === 'adapter_type' ? value : this.state.filterOptCrossAdaptType
		const mountType =									type === 'mount_type' ? value : this.state.filterOptMountType
		const optFullNumb =								type === 'opt_full_numb' ? value : this.state.filterOptFullNumb
		const adapterNumb =								type === 'adapter_numb' ? value : this.state.filterOptCrossAdaptQuant

		let list = this.state.optCrossList.filter(item => !item.Code.includes('-000'))

		list = this.filterArray(fiberType, list, FIBER_CLASS)
		list = this.filterArray(adapterNumb, list, ADAPTER_NUMB)
		list = this.filterArray(mountType, list, MOUNT_TYPE)
		list = this.filterArray(optFullNumb, list, MODUL_NUM)
		if (adapterType !== 'Выбрать') {
			list = list.filter(item => item.adapter_type === adapterType)
		}

		return list

	}
	changeOptCrossFilterOptions(itemList, value = null, type = null){

		const adapterType =								type === 'adapter_type' ? value : this.state.filterOptCrossAdaptType
		const mountType =									type === 'mount_type' ? value : this.state.filterOptMountType
		const optFullNumb =								type === 'opt_full_numb' ? value : this.state.filterOptFullNumb
		const adapterNumb =								type === 'adapter_numb' ? value : this.state.filterOptCrossAdaptQuant

		let optCrossPoleOptions						= this.state.optCrossPoleOptions
		let optCrossAdaptTypeOptions			= this.state.optCrossAdaptTypeOptions
		let optMountTypeOptions						= this.state.optMountTypeOptions
		let optFullNumbOptions						= this.state.optFullNumbOptions
		let optCrossAdaptQuantOptions			= this.state.optCrossAdaptQuantOptions

		if (adapterNumb === 'Выбрать') optCrossAdaptQuantOptions = this.orderArray(this.getArrayFromAttribute(itemList, ADAPTER_NUMB))
		if (mountType === 'Выбрать') optMountTypeOptions = this.getArrayFromAttribute(itemList, MOUNT_TYPE)
		if (optFullNumb === 'Выбрать') optFullNumbOptions = this.getArrayFromAttribute(itemList, MODUL_NUM)
		if (adapterType === 'Выбрать'){
			optCrossAdaptTypeOptions = this.getOptions(itemList, 'adapter_type')
			optCrossAdaptTypeOptions = optCrossAdaptTypeOptions.filter(item => item !== 'без')
		}

		return this.setState({
			optCrossPoleOptions,
			optCrossAdaptTypeOptions,
			optMountTypeOptions,
			optFullNumbOptions,
			optCrossAdaptQuantOptions,
		})

	}

	// Дополнительные компоненты
	openAdd(){
		let itemList = this.getFilteredCableArray()
		const addlist = this.getFilteredAddArray()
		this.changeAddFilterOptions(addlist)
		itemList = [...itemList, ...addlist]
		this.setState({itemList})
	}
	getFilteredAddArray(value = null, type = null){

		const fiberType 							= this.state.filterFibersType
		const polish =									type === 'polish' ? value : this.state.filterAddPole
		const conectorType =						type === 'conector_type' ? value : this.state.filterAddConType
		const addFullNumb =							type === 'add_full_numb' ? value : this.state.filterAddFullNumb

		let optCrossTemplate = this.state.optCrossList.filter(item => item.Code.includes('-000'))

		optCrossTemplate = this.filterArray(addFullNumb, optCrossTemplate, MODUL_NUM)

		let addList = this.state.addList

		let plugList = this.state.plugList
		if (conectorType !== 'Выбрать'){
			plugList = plugList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === MATCH_FOR})
				if (intArray.length){
					return intArray[0].value.includes(conectorType)
				}
			})
			plugList = plugList.filter(Boolean)
		}


		let adapterList = this.state.adapterList
		if (conectorType !== 'Выбрать'){
			adapterList = adapterList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === CONNECTOR_TYPE1 || item.Attribute === CONNECTOR_TYPE2})
				if (intArray.length){
					return intArray[0].value === conectorType || intArray[1].value === conectorType
				}
			})
			adapterList = adapterList.filter(Boolean)
		}
		if (polish !== 'Выбрать') {
			adapterList = adapterList.filter(item => item.polish === polish)
		}


		let addModuleList = this.state.addModuleList
		if (conectorType !== 'Выбрать'){
			addModuleList = addModuleList.filter(item =>{
				let intArray = item.Features.filter(item => {return item.Attribute === MATCH_FOR})
				if (intArray.length){
					return intArray[0].value.includes(conectorType)
				}
			})
			addModuleList = addModuleList.filter(Boolean)
		}
		addModuleList = this.filterArray(polish, addModuleList, POLISH)


		let pigtailList = this.state.pigtailList
		pigtailList = this.filterArray(fiberType, pigtailList, FIBER_TYPE_PATCH)
		pigtailList = this.filterArray(conectorType, pigtailList, PLUG_TYPE)
		pigtailList = this.filterArray(polish, pigtailList, POLISH)


		let panelList = this.state.panelList
		panelList = this.filterArray(fiberType, panelList, FIBER_CLASS)

		return [
			...addList,
			...plugList,
			...adapterList,
			...addModuleList,
			...pigtailList,
			...panelList,
			...optCrossTemplate
		]

	}
	changeAddFilterOptions(itemList, value = null, type = null){

		const polish =										type === 'polish' ? value : this.state.filterAddPole
		const conectorType =							type === 'conector_type' ? value : this.state.filterAddConType
		const addFullNumb =								type === 'add_full_numb' ? value : this.state.filterAddFullNumb

		let addPoleOptions							= this.state.addPoleOptions
		let addConTypeOptions						= this.state.addConTypeOptions
		let addFullNumbOptions					= this.state.addFullNumbOptions

		if (polish === 'Выбрать') addPoleOptions = this.getArrayFromAttribute(itemList, POLISH)
		if (conectorType === 'Выбрать') {
			addConTypeOptions = this.getArrayFromAttribute(itemList, PLUG_TYPE)
			addConTypeOptions = this.clearFromDouble(addConTypeOptions)
		}
		if (addFullNumb === 'Выбрать') addFullNumbOptions = this.getArrayFromAttribute(itemList, MODUL_NUM)



		return this.setState({
			addPoleOptions,
			addConTypeOptions,
			addFullNumbOptions,
		})

	}

	clearFromDouble(array){
		return this.delDuplicatesFromArray(array.map(item =>item === 'Выбрать' ? item :  item.slice(0,2)))
	}

	// -- Логика

	// Рендер
	render() {
		return (
			<div className={styles.cfg}>
				{/*Белый фон и лого*/}
				<div style={{position: 'absolute', margin: '0 auto', backgroundColor: '#fff', width: '10%', height: '80px'}}/>
				<Image
					className={styles.logo}
					blockChangeScale={true}
				/>
				{/*Зеленый фон заголовка*/}
				<div style={{margin: '0 auto', backgroundColor: '#76D750', width: '100%', height: '80px'}}/>
				<div className={styles.title}>Подбор оптических компонентов ITK</div>

				<div>
					{/*Необходим специальный инструмент*/}
					<div className={styles.mainSectionTitle}>Подбор кабелей</div>
					{this.cableDropDown ? this.cableDropDown() : null}
					<div style={{
						position: 'absolute',
						top: '100px',
						left: '20px',
						margin: '0 auto',
						backgroundColor: '#fff',
						width: '440px',
						height: '160px',
						zIndex: '1'
					}}/>
				</div>

				<FilterRouter app={this}/>

				{/*Спецификация*/}
				<Table
					title='Аксессуары'
					type='NoBucket'
					items={this.state.itemList}
					styles={{
						width: '440px',
						height: this.state.tableHeight,
						top: this.state.tableTop,
						left: '20px',
						fontSize: '12px'
					}}
					onSelect={this.onListItemCheck}
					addBasket={this.addBasket}
					itemInfo={this.state.itemInfo}
					color='#76d750'
				/>

				{/*Середина*/}
				{/*Корзина*/}
				<Table
					title='Корзина'
					type='Bucket'
					items={this.state.specList}
					styles={{width: '440px', height: '585px', top: '100px', left: '480px', fontSize: '12px'}}
					onSelect={this.onListItemCheck}
					onDelete={this.onDelete}
					onChangeQuantity={this.onChangeQuantity}
					color='#76d750'
					configType='optic'
				/>

				<div className={styles.sum}>Сумма: {this.state.summ} руб.</div>

				{/*Правая часть*/}
				{/* Артикул и имя */}
				<div className={styles.itemInfoBG}/>
				{this.state.itemInfo && this.state.itemInfo[0] ? (
					<a href={`https://qr.iek.group/${this.state.itemInfo[0] && this.state.itemInfo[0].art}`}
						 target="_blank">
						<div className={styles.itemInfo}>
							<div className={styles.itemInfo_Article}>{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].art}</div>
							<div>{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].name}</div>
						</div>
					</a>
				) : (
					<div className={styles.itemInfoNoArticle}/>
				)}

				{/* Фото */}
				<Image
					className={styles.itemImg}
					url={this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].ImgPng[0].file_ref.uri ? this.state.itemInfo[0].ImgPng[0].file_ref.uri : null}
				/>

				{/* Описание */}
				<div style={{
					position: 'absolute',
					top: '452px',
					left: '940px',
					backgroundColor: '#fff',
					width: '434px',
					height: '292px'
				}}/>
				{this.state.itemInfo && this.state.itemInfo[0] && this.state.itemInfo[0].Description[0].desc_ru ? (
					<div className={styles.description}>
						{this.state.itemInfo[0].Description[0].desc_ru}
					</div>
				) : (
					<div className={styles.descriptionEmpty}>
					</div>
				)}


				{/*Кнопки*/}
				{this.getCustomButtons ? this.getCustomButtons() : null}

				{/*Нижняя плашка*/}
				{/* На основной сайт IEK */}
				<div style={{position:'absolute', backgroundColor: '#ffffff', width: '50%', height: '20px', top:'820px'}}/>
				<a  className={styles.homeLink} href={'https://www.itk-group.ru/'} target="_blank">На основной сайт ITK</a>

				{/* Техническая поддержка */}
				<div style={{position:'absolute', backgroundColor: '#76D750', width: '50%', height: '20px', top:'820px', left: '700px'}}/>
				<a style={{
					position: 'absolute',
					top: '823px',
					left: '415px',
					color: '#37424a',
					width: '141px',
					height: '14px'
				}} href={'https://www.itk-group.ru/servis-i-podderzhka/'} target="_blank">Техническая поддержка:
				</a>
				<span className={styles.techSupport}>+7 (495) 542-22-24</span>

			</div>
		)
	}

}

/**
 * Фильтр кабелей и компонентов для подбора
 */
class FilterRouter extends React.Component {
	render() {

		let filter = null;

		switch (this.props.app.state.filterDevice) {

			case 'patch_cord':
				filter = <FilterModePatchCord {...this.props} />;
				break;

			case 'pigtail':
				filter = <FilterModePigital {...this.props} />;
				break;

			case 'opt_cross':
				filter = <FilterModeOptCross {...this.props} />;
				break;
		}

		return (
			<div>

				<span className={styles.filterLable}>Подобрать:</span>

				<select
					className={styles.filter}
					onChange={this.props.app.onFilterChange}
					value={this.props.app.state.filterDevice}
					disabled={!this.props.app.state.addFilterEnabled}
				>
					<option value="Выбрать">Выбрать</option>
					<option value="pigtail">Пигтейлы</option>
					<option value="patch_cord">Патч-корды</option>
					<option value="opt_cross">Оптические кроссы</option>
				</select>

				<div style={{
					position: 'absolute',
					top: '285px',
					left: '300px',
					zIndex: '1',
					width: '200px',
				}}>* - необходимо выбрать все фильтры для подбора дополнительных аксессуаров</div>

				{filter}
			</div>
		);
	}
}

/**
 * Патч-корды
 */
class FilterModePatchCord extends React.Component {
	render() {

		return (
			<div>
				{/*Необходим специальный инструмент*/}
				<div className={styles.addSectionTitle}>Подбор патч-кордов</div>
				{this.props.app.patchCordDropDown ? this.props.app.patchCordDropDown() : null}
				<div style={{
					position: 'absolute',
					top: '341px',
					left: '20px',
					margin: '0 auto',
					backgroundColor: '#fff',
					width: '440px',
					height: '115px',
					zIndex: '1'
				}}/>
			</div>
		);
	}
}

/**
 * Пигтейл
 */
class FilterModePigital extends React.Component {
	render() {

		return (
			<div>
				{/*Необходим специальный инструмент*/}
				<div className={styles.addSectionTitle}>Подбор пигтейлов</div>
				{this.props.app.pigtailDropDown ? this.props.app.pigtailDropDown() : null}
				<div style={{
					width: '440px',
					height: '115px',
					top: '341px',
					left: '20px',
					margin: '0 auto',
					backgroundColor: '#fff',
					position: 'absolute',
					zIndex: '1'
				}}/>
			</div>
		);
	}
}

/**
 * Оптические кроссы
 */
class FilterModeOptCross extends React.Component {
	render() {
		return (
			<div>
				<div className={styles.addSectionTitle}>Подбор оптических кроссов</div>
				<RadioGroup
					type='turnkey'
					x={40}
					y={390}
					distance={200}
					options={this.props.app.state.optCrossTurnkeyOptions}
					value={this.props.app.state.filterTurnkey}
					onChange={this.props.app.onTurnkeyChange}
				/>

				{ this.props.app.state.filterTurnkey === COMPLECT
					?
					this.props.app.optCrossDropDown ? this.props.app.optCrossDropDown() : null
					:
					this.props.app.addDropDown ? this.props.app.addDropDown() : null
				}
				<div style={{
					position: 'absolute',
					top: '341px',
					left: '20px',
					margin: '0 auto',
					backgroundColor: '#fff',
					width: '440px',
					height: this.props.app.state.optCrossBGHeight,
					zIndex: '1'
				}}/>
			</div>
		);
	}
}


class DropDown extends React.Component {

	render() {
		let typeCap = this.props.app.capitalizeFirstLetter(this.props.type)

		return <div>
			<span className={styles.selectLabel} style={{top: this.props.y + 'px', left: this.props.x + 'px'}}>{this.props.header}</span>
			<select
				className={styles.selectBase}
				style={{top: this.props.y + 17 + 'px', left: this.props.x + 'px'}}
				onChange={this.props.app['on' + typeCap + 'Change']}
				value={this.props.app.state['filter' + typeCap]}
				disabled={!(this.props.app.state[this.props.type + 'Options'].length > 1)}
			> {this.props.app.state[this.props.type + 'Options'].length > 0
				? this.props.app.state[this.props.type + 'Options'].map((option, index) => {
					return (
						<option value={option} key={index + option}>{option} </option>)
				})
				: <option value="Выбрать">Выбрать</option>
			}
			</select>
		</div>
	}

}

class RadioGroup extends React.Component {
	render() {
		const {options, type, x, y, value, onChange, disabled, distance} = this.props
		return <div>
			{options.map((radio, idx) => {
				return (
					<div key={type + "radio" + idx}>
						<label
							htmlFor={type + "radio" + idx}
							style={{
								top: y + 5 + 'px',
								left: x + 30 + (idx * (	distance ? distance : 100 )) + 'px',
								position: 'absolute',
								zIndex: '10',
								height: '16px',
								width: '160px'
							}}
						>{radio}</label>
						<input
							id={type + "radio" + idx}
							style={{
								top: y + 'px',
								left: x + (idx * (	distance ? distance : 100 )) + 'px',
								position: 'absolute',
								zIndex: '10',
								height: '16px',
								width: '16px'
							}}
							type="radio"
							name="radio"
							value={radio}
							disabled={disabled}
							checked={value === radio}
							onChange={onChange}
						/>
					</div>)
			})}
		</div>
	}
}


export default OpticConfigurator;



// WEBPACK FOOTER //
// ./src/react/OpticConfigurator.jsx